import Dexie, { Table } from 'dexie';
import { Message } from '../types';

// IndexedDB wrapper for persistent message caching
class ConversationCache extends Dexie {
  messages!: Table<Message & { conversationId: string }>;
  
  constructor() {
    super('ConversationCache');
    this.version(1).stores({
      messages: '++id, conversationId, timestamp'
    });
  }
  
  async cacheMessages(conversationId: string, messages: Message[]) {
    // Clear old messages for this conversation
    await this.messages.where('conversationId').equals(conversationId).delete();
    
    // Add new messages with conversationId
    const messagesWithConvId = messages.map(msg => ({
      ...msg,
      conversationId
    }));
    
    await this.messages.bulkAdd(messagesWithConvId);
  }
  
  async getCachedMessages(conversationId: string): Promise<Message[]> {
    const cached = await this.messages
      .where('conversationId')
      .equals(conversationId)
      .toArray();
      
    return cached.map(({ conversationId, ...msg }: any) => msg);
  }
  
  async updateCache(conversationId: string, newMessage: Message) {
    await this.messages.add({
      ...newMessage,
      conversationId
    });
  }
  
  async clearConversationCache(conversationId: string) {
    await this.messages.where('conversationId').equals(conversationId).delete();
  }
}

export const conversationCache = new ConversationCache();
